import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './styles/index.css';
import { Router, Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import NotFoundPage from './components/pages/NotFoundPage';
import SplashPage from './components/pages/SplashPage';
import LogInPage from './components/pages/auth/LogInPage';
import AdminPage from './components/pages/admin/AdminPage';
import BmxOauthSignRedirectRoute from './components/pages/admin/BmxOauthSignRedirectRoute';
import RegisterPage from './components/pages/auth/RegisterPage';
import ForgotPasswordPage from './components/pages/auth/ForgotPasswordPage';
import ForgotPasswordConfirmationPage from './components/pages/auth/ForgotPasswordConfirmationPage';
import ResetPasswordPage from './components/pages/auth/ResetPasswordPage';
import { browserHistory } from './utilities/history';
import { configureAppInsightsLogging } from './utilities/logging';
import LockConnectPage from './components/pages/LockConnectPage';
import EntrataConnectPage from './components/pages/EntrataConnectPage';
import ProspectRouter from './components/pages/prospect/ProspectRouter';
import {
    propertySlugCapture,
    ProspectBasePath,
    TourBasePath
} from './components/pages/prospect/ProspectRouteValues';
import TourRouter, {
    TourPage,
    tourSignupPath
} from './components/pages/prospect/signup/TourRouter';
import SimpleFaqsPage from './components/pages/prospect/public/SimpleFaqsPage';
import AuthorizedRoute from './components/common/AuthorizedRoute';
import { AdminRoles } from './utilities/Enums';

export const confirmLockPath = '/confirmlock';

configureAppInsightsLogging();

const App: React.FC = () => {

  return (
    <Router history={browserHistory}>
      <Switch>
        <Route path="/bmx-redirect/?propertyId=:propertyId" component={BmxOauthSignRedirectRoute} />
        <Route path={`${TourBasePath}/${propertySlugCapture}`} component={TourRouter} />
        <Route path={ProspectBasePath} component={ProspectRouter} />
        <Route path="/login" component={LogInPage} />
        <Route path="/register" component={RegisterPage} />
        <AuthorizedRoute path="/admin" component={AdminPage} roles={AdminRoles} />
        <Route path="/forgotpassword" component={ForgotPasswordPage} />
        <Route path="/forgotpasswordconfirmation" component={ForgotPasswordConfirmationPage} />
        <Route path="/resetpassword" component={ResetPasswordPage} />
        <Route path="/faq" component={SimpleFaqsPage} />
        <Route path="?referrer=:referrerValue" component={EntrataConnectPage} />
        <Route path={confirmLockPath} component={LockConnectPage} />
        <AuthorizedRoute
          path="/"
          exact={true}
          render={props => {
        
            const referrer = new URLSearchParams(props.location.search).get('referrer');

            return referrer === 'propertysolutions' ? (
              <EntrataConnectPage {...props} />
            ) : (
              <>
                
                <SplashPage text="Your tour starts here" />
        
              </>
            );
          }}
          roles={AdminRoles}
        />
        <Route
          path="/tour/:propertyId"
          render={(props: RouteComponentProps<{ propertyId: string }>) => (
            <Redirect
              to={
                tourSignupPath(props.match.params.propertyId)(TourPage.Registration) +
                props.location.search
              }
            />
          )}
        />
        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  );
};

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);



// WEBPACK FOOTER //
// ./src/index.tsx